import { createAction, props } from '@ngrx/store';
import { ISubmitResponse } from '@shared/services';

export const validateInternalTransferOpenAccount = createAction(
  '[Open Account] Validate internal transfer open account',
);

export const validateInternalTransferOpenAccountResponse = createAction(
  '[Open Account] Validate internal transfer Open account response',
  props<{ payload: boolean }>(),
);

export const validateInternalTransferOpenAccountFailure = createAction(
  '[Open Account] Validate internal transfer open account failure',
);

export const submitInternalTransferOpenAccount = createAction(
  '[Open Account] Submit internal transfer open account',
);

export const submitInternalTransferOpenAccountComplete = createAction(
  '[Open Account] Submit internal transfer open account complete',
);

export const submitInternalTransferOpenAccountFailure = createAction(
  '[Open Account] Submit internal transfer open account failure',
);

export const submitInternalTransferOpenAccountResponse = createAction(
  '[Open Account] Submit internal transfer open account response',
  props<{ payload: ISubmitResponse }>(),
);
